// extracted by mini-css-extract-plugin
module.exports = {"noSnippetMessage":"SnippetList_noSnippetMessage__3gQER"};